import services from '@/services'

export default (context, inject) => {
  const { $axios, store, $helpers, $notify } = context
  const apiServices = services($axios, { $store: store, $helpers, $notify })
  inject('api', apiServices)
}
